import React from "react";
import { ArrowForward, ArrowBack, ReceiptOutline, LogOutOutline, ArrowBackCircle, LogoDropbox } from 'react-ionicons'
import stylesWMS from "./stylesWMS"
import { Modal } from 'react-bootstrap';
import _post from "../Functions/NoBodyPost"
import constantURI from "../URI"
import { WMSDB } from "../ConstantURI"
import stylesASAP from "../ASAP/stylesASAP"

export default class LandingPageWMS extends React.Component {

    constructor() {
        super();
        this.state = {
            In: "",
            Out: "",
            showAlertChange: false,
            module: 0,
            loading: true,
            username:""
        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        var username = JSON.parse(localStorage.getItem('Username'));
        var password = JSON.parse(localStorage.getItem('Password'));
        var token = JSON.parse(localStorage.getItem('Token'));
        const db = WMSDB;
        const url = constantURI() + "Authentication?token=" + token+ "&user=" + username + "&username=" + username + "&password=" + password + "&db=" + db;
        await _post(url).then((response) => {
            return response.json().then(async (data) => {
                if (data.result === undefined) {
                    this.setState({ alertUndefined: true });
                }
                else {
                    const typeUrl = constantURI() + "GetUserType?token=" + token+ "&user=" + username + "&username=" + username;
                    await _post(typeUrl).then((response) => {
                        return response.json().then(async (data) => {
                            if (data.result === undefined || data.result[0] === undefined || data.result[0].user_type_id[0] === undefined) {
                                this.setState({ alertUndefined: true, loading: false });
                            }
                            else {
                                if (data.result[0].user_type_id[0] === 2) {
                                    await this.setState({ module: 0, loading: false });
                                    await localStorage.setItem("UserType", JSON.stringify(0));
                                }
                                else if (data.result[0].user_type_id[0] === 4) {
                                    await this.setState({ module: 1, loading: false });
                                    await localStorage.setItem("UserType", JSON.stringify(1));
                                }
                                else if (data.result[0].user_type_id[0] === 6) {
                                    await this.setState({ module: 4, loading: false });
                                    await localStorage.setItem("UserType", JSON.stringify(4));
                                }
                            }
                        })
                    })
                }
            })
        })
    }

    closeAlertChange = () => {
        this.setState({ showAlertChange: false })
    }

    showAlertChange = () => {
        this.setState({ showAlertChange: true });
    }

    onClickIn = () => {
        this.props.history.push("/" + this.state.In);
    }

    onClickOut = () => {
        this.props.history.push("/" + this.state.Out);
    }

    onClickTransfers = () => {
        if (this.state.module === 1) {
            localStorage.setItem("Interface", JSON.stringify(1))
        }
        else if (this.state.module === 0) {
            localStorage.setItem("Interface", JSON.stringify(2))
        }
        this.props.history.push("/Transfers");
    }

    onClickRequests = () => {
        localStorage.setItem("Interface", JSON.stringify(0))
        this.props.history.push("/Transfers");
    }

    render() {
        console.log(this.state.module);
        if (!this.state.loading) {
            return (
                <div className="container-fluid" style={stylesWMS.mainContainer}>
                    <div className="pt-3">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./Modules")} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    {(this.state.module === 0 || this.state.module === 3) ?
                        <div>
                            <div className="row mt-3" >
                                <div className="btn card col text-center pt-3 Box-Shadow m-2" style={stylesWMS.mainContainer} onClick={() => this.props.history.push("/Requests")}>
                                    <ArrowForward className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <h4 className="card-text" style={stylesWMS.itemName}>Pick & Pack</h4>
                                </div>
                                <div className="btn card col text-center pt-3 Box-Shadow m-2" style={stylesWMS.mainContainer} onClick={() => this.onClickTransfers()}>
                                    <ReceiptOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <h4 className="card-text" style={stylesWMS.itemName}>Transfers</h4>
                                </div>
                            </div>
                            <div className="row" >
                                <div className="btn card col text-center pt-3 Box-Shadow m-2" style={stylesWMS.mainContainer} onClick={() => { this.props.history.push("/Transfers"); localStorage.setItem("Interface", JSON.stringify(3)) }}>
                                    <ArrowBack className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <h4 className="card-text" style={stylesWMS.itemName}>Repackaging</h4>
                                </div>
                                <div className="btn card col text-center pt-3 Box-Shadow m-2" style={stylesWMS.mainContainer} onClick={() => this.props.history.push("/Packages")}>
                                    <LogoDropbox className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <h4 className="card-text" style={stylesWMS.itemName}>Packages</h4>
                                </div>
                            </div>
                            <div className="row" >
                                <div className="btn card col text-center pt-3 Box-Shadow m-2" style={stylesWMS.mainContainer} onClick={() => this.props.history.push("/")}>
                                    <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <h4 className="card-text" style={stylesWMS.itemName}>Logout</h4>
                                </div>
                                <div className="btn card col text-center pt-3 Box-Shadow invisible m-2" style={stylesWMS.mainContainer} onClick={() => this.props.history.push("/")}>
                                    <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <h4 className="card-text" style={stylesWMS.itemName}>Logout</h4>
                                </div>
                            </div>
                        </div>
                        :
                        (this.state.module === 1) ?
                            <div>
                                <div className="row" >
                                    <div className="btn card col text-center pt-3 Box-Shadow pt-3 m-2" style={stylesWMS.mainContainer} onClick={() => this.onClickTransfers()}>
                                        <ReceiptOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                        <h4 className="card-text" style={stylesWMS.itemName}>Transfers</h4>
                                    </div>
                                    <div className="btn card col text-center pt-3 Box-Shadow pt-3 m-2" style={stylesWMS.mainContainer} onClick={() => this.props.history.push("/")}>
                                        <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                        <h4 className="card-text" style={stylesWMS.itemName}>Logout</h4>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                    <Modal show={this.state.showAlertChange} onHide={this.closeAlertChange} animation={false}>
                        <Modal.Header>
                            <Modal.Title>Choose an Option</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col">
                                    <div className="btn" style={stylesWMS.deleteButtonAlert} onClick={() => this.onClickIn()}>{this.state.In} In</div>
                                </div>
                                <div className="col d-flex flex-row-reverse">
                                    <div className="btn" style={stylesWMS.deleteButtonAlert} onClick={() => this.onClickOut()}>{this.state.Out} Out</div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div >
            );
        }
        else {
            return (
                <div className="container-fluid" style={stylesWMS.mainContainer}>
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesASAP.spinner}></div>
                    </div>
                </div>
            );
        }
    }
}
